// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Po+Ly","container":"styles_container__7u04T","background":"styles_background__XcIod"};